import React, { useState, useEffect } from "react";
import { ethers } from "ethers";

// --- IMPORTANT: REPLACE WITH YOUR CONTRACT DETAILS ---
const YOUR_CONTRACT_ADDRESS = "0x848386ee769f188777d2B0c63c8EDe41D6996ee3"; // e.g., "0x123..."
// Minimal ABI for balanceOf and decimals. You'll need a more complete ABI if you add burn functions.
const YOUR_CONTRACT_ABI = [
  {
    inputs: [
      { internalType: "uint256", name: "initialSupply", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "allowance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" },
    ],
    name: "ERC20InsufficientAllowance",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "uint256", name: "balance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" },
    ],
    name: "ERC20InsufficientBalance",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "approver", type: "address" }],
    name: "ERC20InvalidApprover",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "receiver", type: "address" }],
    name: "ERC20InvalidReceiver",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "ERC20InvalidSender",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "spender", type: "address" }],
    name: "ERC20InvalidSpender",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "index", type: "uint256" }],
    name: "approveBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "holder", type: "address" }],
    name: "burnExpiredTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "getBatches",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "amount", type: "uint256" },
          { internalType: "uint256", name: "expiry", type: "uint256" },
          { internalType: "bool", name: "approved", type: "bool" },
        ],
        internalType: "struct ExpiringCarbonToken.TokenBatch[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "uint256", name: "expiryTimestamp", type: "uint256" },
    ],
    name: "issueTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "tokenBatches",
    outputs: [
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "uint256", name: "expiry", type: "uint256" },
      { internalType: "bool", name: "approved", type: "bool" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];
// Add functions for burning tokens here if your contract supports them
// e.g., { "name": "burnExpiredTokens", "type": "function", ... }

function App() {
  const [account, setAccount] = useState(null);
  const [provider, setProvider] = useState(null);
  const [contract, setContract] = useState(null);
  const [balance, setBalance] = useState("0");
  const [tokenSymbol, setTokenSymbol] = useState("CCT");
  const [isConnected, setIsConnected] = useState(false);
  const [approveBurn, setApproveBurn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Mock expiry date as per the image
  const expiryDate = "May 30, 2025"; // Update this as needed or fetch from contract if available

  useEffect(() => {
    if (window.ethereum) {
      const web3Provider = new ethers.BrowserProvider(window.ethereum);
      setProvider(web3Provider);

      // Listen for account changes
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          handleAccountChange(accounts[0], web3Provider);
        } else {
          disconnectWallet();
        }
      });

      // Listen for network changes
      window.ethereum.on("chainChanged", () => {
        // Reload or re-initialize to handle network changes correctly
        window.location.reload();
      });
    } else {
      console.log("MetaMask not detected. Please install MetaMask.");
      setMessage("MetaMask not detected. Please install MetaMask.");
    }
  }, []);

  const handleAccountChange = async (newAccount, web3Provider) => {
    setAccount(newAccount);
    setIsConnected(true);
    if (
      YOUR_CONTRACT_ADDRESS !== "YOUR_DEPLOYED_CONTRACT_ADDRESS_HERE" &&
      YOUR_CONTRACT_ABI.length > 3
    ) {
      const signer = await web3Provider.getSigner();
      const tokenContract = new ethers.Contract(
        YOUR_CONTRACT_ADDRESS,
        YOUR_CONTRACT_ABI,
        signer
      );
      setContract(tokenContract);
      fetchBalance(newAccount, tokenContract);
      fetchTokenSymbol(tokenContract);
    } else {
      setBalance("N/A"); // Contract details not set
      setTokenSymbol("N/A");
      setMessage("Please update contract address and ABI in the code.");
    }
  };

  const connectWallet = async () => {
    if (!provider) {
      setMessage("MetaMask not available.");
      return;
    }
    setIsLoading(true);
    setMessage("");
    try {
      const accounts = await provider.send("eth_requestAccounts", []);
      if (accounts.length > 0) {
        await handleAccountChange(accounts[0], provider);
      }
    } catch (error) {
      console.error("Error connecting wallet:", error);
      setMessage(
        `Error connecting: ${error.message || "User rejected connection."}`
      );
      setIsConnected(false);
    }
    setIsLoading(false);
  };

  const disconnectWallet = () => {
    setAccount(null);
    setIsConnected(false);
    setBalance("0");
    setContract(null);
    setMessage("Wallet disconnected.");
  };

  const fetchBalance = async (currentAccount, tokenContract) => {
    if (!tokenContract || !currentAccount) return;
    try {
      const rawBalance = await tokenContract.balanceOf(currentAccount);
      const decimals = await tokenContract.decimals();
      const formattedBalance = ethers.formatUnits(rawBalance, decimals);
      setBalance(formattedBalance);
    } catch (error) {
      console.error("Error fetching balance:", error);
      setBalance("Error");
      setMessage(
        "Error fetching token balance. Is the contract address and network correct?"
      );
    }
  };

  const fetchTokenSymbol = async (tokenContract) => {
    if (!tokenContract) return;
    try {
      const symbol = await tokenContract.symbol();
      setTokenSymbol(symbol);
    } catch (error) {
      console.error("Error fetching token symbol:", error);
      setTokenSymbol("N/A");
    }
  };

  const handleBurnTokens = async () => {
    if (!contract) {
      setMessage("Connect wallet and ensure contract is loaded.");
      return;
    }
    if (!approveBurn) {
      setMessage("Please approve burn after expiryFFFFFFFFF.");
      return;
    }

    setIsLoading(true);
    setMessage("Attempting to burn tokens...");

    // --- THIS IS A PLACEHOLDER ---
    // You need to implement the actual burn logic based on your smart contract.
    // For example, your contract might have a function like:
    // await contract.burnExpiredTokens();
    // Or:
    // await contract.burn(amountToBurn);
    try {
      // Example: if your contract has a function `burnMyExpiredTokens()`
      // const tx = await contract.burnMyExpiredTokens();
      // await tx.wait();
      // setMessage("Tokens burned successfully!");
      // fetchBalance(account, contract); // Refresh balance

      // For now, simulate a delay and success message
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setMessage(
        "Burn functionality is not yet implemented with the smart contract. This is a UI demonstration."
      );
      console.warn(
        "Burn functionality needs to be implemented in `handleBurnTokens` and your smart contract."
      );
    } catch (error) {
      console.error("Error burning tokens:", error);
      setMessage(
        `Error burning tokens: ${error.message || "Transaction failed."}`
      );
    }
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex flex-col items-center justify-center p-4 font-sans text-gray-200">
      <div className="bg-slate-800 shadow-2xl rounded-xl p-6 md:p-8 w-full max-w-md border border-slate-700">
        {/* Header */}
        <div className="flex justify-between items-center mb-6 pb-4 border-b border-slate-700">
          <h1 className="text-xl md:text-2xl font-bold text-emerald-400">
            CARBON CREDIT TOKEN DAPP
          </h1>
          {!isConnected ? (
            <button
              onClick={connectWallet}
              disabled={isLoading}
              className="bg-emerald-500 hover:bg-emerald-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-150 ease-in-out disabled:opacity-50"
            >
              {isLoading ? "Connecting..." : "Connect Wallet"}
            </button>
          ) : (
            <div className="text-right">
              <span className="text-sm bg-green-500 text-white px-3 py-1 rounded-full">
                Connected
              </span>
              <p
                className="text-xs text-gray-400 mt-1 truncate"
                title={account}
              >
                {account
                  ? `${account.substring(0, 6)}...${account.substring(
                      account.length - 4
                    )}`
                  : "No account"}
              </p>
            </div>
          )}
        </div>

        {message && (
          <div
            className={`mb-4 p-3 rounded-md text-sm ${
              message.includes("Error") ||
              message.includes("not detected") ||
              message.includes("failed")
                ? "bg-red-500/20 text-red-300"
                : "bg-blue-500/20 text-blue-300"
            }`}
          >
            {message}
          </div>
        )}

        {/* Your Tokens Section */}
        {isConnected && account && (
          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-300 mb-3">
              Your Tokens
            </h2>
            <div className="bg-slate-700/50 p-4 rounded-lg shadow">
              <p className="text-gray-400">
                Balance:{" "}
                <span className="font-bold text-emerald-400 text-xl">
                  {balance} {tokenSymbol}
                </span>
              </p>
              <p className="text-gray-400 mt-1">
                Expiry Date:{" "}
                <span className="font-semibold text-gray-200">
                  {expiryDate}
                </span>
              </p>
            </div>
          </div>
        )}

        {/* Burn Expired Tokens Section */}
        {isConnected && account && (
          <div>
            <hr className="border-slate-700 my-6" />
            <h2 className="text-lg font-semibold text-gray-300 mb-3">
              Burn Expired Tokens
            </h2>
            <div className="bg-slate-700/50 p-4 rounded-lg shadow">
              <div className="flex items-center mb-4">
                <input
                  id="approveBurn"
                  type="checkbox"
                  checked={approveBurn}
                  onChange={(e) => setApproveBurn(e.target.checked)}
                  className="w-5 h-5 text-emerald-500 bg-slate-600 border-slate-500 rounded focus:ring-emerald-400 focus:ring-offset-slate-800"
                />
                <label
                  htmlFor="approveBurn"
                  className="ml-2 text-sm text-gray-300"
                >
                  Approve burn after expiry
                </label>
              </div>
              <button
                onClick={handleBurnTokens}
                disabled={!approveBurn || isLoading}
                className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-2.5 px-4 rounded-lg transition duration-150 ease-in-out disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {isLoading ? "Processing..." : "Burn Tokens"}
              </button>
            </div>
          </div>
        )}

        {!isConnected &&
          !account &&
          !message.includes("MetaMask not detected") && (
            <div className="text-center py-10">
              <p className="text-gray-400">
                Please connect your wallet to view your tokens and interact with
                the DApp.
              </p>
            </div>
          )}
      </div>
      <footer className="text-center mt-8 text-xs text-slate-500">
        <p>
          Ensure you are connected to the correct network (e.g., Sepoile
          Testnet).
        </p>
        <p>This DApp is for demonstration purposes.</p>
      </footer>
    </div>
  );
}

export default App;
